export class ImportReport {
    public isFileTreatmentError!: boolean;
    public isImportError!: boolean;
    public errorsReport: ImportError[] = [];
    public isFinished!: boolean;
    public progress: ImportProgress = new ImportProgress();
}

class ImportError {
    public httpCode!: number;
    public display!: string;
    public message!: string;
}

class ImportProgress {
    public total!: number;
    public completed: number = 0;
}
